import { inboundShipmentIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const deleteShipment = {
  name: "deleteShipment" as const,
  input: z.object({ shipmentId: inboundShipmentIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
